import * as React from "react";

import "../styles/InfoButton.css";

import InfoIcon from '@material-ui/icons/Info';

export default class InfoButton extends React.Component
{
    constructor(props)
    {
        super(props);
    }

    infoAction = (aEvent) =>
    {
        aEvent.stopPropagation();
    }

    render()
    {
        const sTargetUrl = this.props.target;
        const nIconSize = this.props.size;

        return (
            <a
                href={sTargetUrl}
                className="InfoButton"
                onClick={this.infoAction}
                title={sTargetUrl}
            >
                <InfoIcon style={{
                    fontSize: (nIconSize && !isNaN(nIconSize)) ? nIconSize : 14
                }} />
            </a>
        );
    }
}